import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PriceModel } from './Price.model';
export class AppliedDiscountModel {
  constructor(appliedDiscountModel) {
    _defineProperty(this, "discountType", void 0);
    _defineProperty(this, "discountRule", void 0);
    _defineProperty(this, "lineItemIds", void 0);
    this.discountRule = appliedDiscountModel.discountRule;
    this.discountType = appliedDiscountModel.discountType;
    this.lineItemIds = appliedDiscountModel.lineItemIds;
  }
  static fromV1(appliedDiscount, modelContext) {
    return new AppliedDiscountModel({
      discountRule: appliedDiscount.discountRule ? {
        amount: PriceModel.fromV1(appliedDiscount.discountRule.amount, modelContext)
      } : undefined,
      discountType: appliedDiscount.discountType,
      // eslint-disable-next-line import/no-deprecated
      lineItemIds: appliedDiscount.lineItemIds
    });
  }
}
//# sourceMappingURL=AppliedDiscount.model.js.map